$('body').on('click', '.add-year-trigger', function() {
    openModal('.add-year');
    return false;
});

$("body").on("click", ".open-year-menu", function () {
    var $this = $(this);
    var menu = $this.parents(".year-menu-wrapper");

    $(".year-menu", menu).css({
        top: menu.position().top,
        left:
            5 + (menu.position().left + menu.width()) - $(".year-menu", menu).width()
    });

    menu.addClass("opened");
    closeDropdown($this.parents(".year-menu-wrapper").attr("data-dropdown"));
    return false;
});

$('body').on('click', '.edit-year-trigger', function() {
    var data = $(this).parents('.year');
    var action = $('.edit-year form').attr('data-action').replace('{year}', data.attr('data-year'));
    $('.edit-year form').attr('action', action);

    $('.edit-year input[name="name"]').val(data.attr('data-name'));
    $('.edit-year input[name="due_date"]').val(data.attr('data-due_date'));
    $('.edit-year input[name="seat_cost"]').val(data.attr('data-seat_cost'));
    $('.edit-year input[name="active"]').prop('checked', data.attr('data-active') === 'true' ? true : false);

    openModal('.edit-year');
    closeDropdown();
    return false;
});

$('body').on('submit', '.add-year form, .edit-year form', function() {
    var $this = $(this);
    var modal = $this.parents('.modal');
    var fields = $this.serializeArray();
    fields[fields.length] = { name: '_token', value: $('meta[name="csrf-token"]').attr('content') };
    
    var error = false;

    modal.find('.required').each(function() {
        if($(this).val() === '') {
            error = true;
        }
    });

    if(error) {
        showError('Error', 'Please fill out all required fields');
        return false;
    }
    
    loading();
    $.ajax({
        type : 'POST',
        url : $this.attr('action'),
        data : fields,
        dataType : 'json',
        success : function(data) {
            console.log(data);
            unloading();

            if(!data.success) {
                showError('Error', data.message);
                return false;
            }

            closeModal();
            addNotification(data.notification.title, data.notification.message, data.notification.icon);
        },
        error : function(request) {
            console.log(request.responseText);
        }
    });

    return false;
});


channel.bind('process-year', function(data) {
    // console.log(data);
    var element;

    if($('.year[data-year="'+data.year+'"]').length) {
        element = $('.year[data-year="'+data.year+'"]');

		element.attr('data-name', data.name);
		element.attr('data-seat_cost', data.seat_cost);
		element.attr('data-due_date', data.due_date);
        element.attr('data-active', data.active);

        element.find('[data-input="name"]').html(data.name);
        element.find('[data-input="total_seat_cost_parsed"]').html(data.total_seat_cost_parsed);
        element.find('[data-input="total_paid_seats_parsed"]').html(data.total_paid_seats_parsed);
        element.find('[data-input="total_seats"]').html(data.total_seats);
        element.find('[data-input="seat_cost_parsed"]').html(data.seat_cost_parsed);
        element.find('[data-input="total_payments"]').html(data.total_payments);
        element.find('[data-input="total_paid_parsed"]').html(data.total_paid_parsed);
        element.find('[data-input="total_upcoming_payments"]').html(data.total_upcoming_payments);
        element.find('[data-input="total_upcoming_paid_parsed"]').html(data.total_upcoming_paid_parsed);
        element.find('[data-input="due_date"]').html(data.due_date);
		element.find('[data-input="status"]').html(data.status);
		element.find('[data-input="status"]').attr('data-color', data.status_color);
        element.find('.year-menu').html(buttons(data.buttons));
        return;
    }

    if($('body').attr('data-page') === '1') {
        element = $('<tr>', {
            class: 'year',
            'data-year': data.year,
            'data-name': data.name,
            'data-seat_cost': data.seat_cost,
            'data-active': data.active,
            'data-due_date': data.due_date
        });

        element.append(`<td data-input="name">${data.name}</td>
        <td>
            <p>
                (<span data-input="total_seats">${data.total_seats}</span>)
                <span data-input="total_seat_cost_parsed">${data.total_seat_cost_parsed}</span>
            </p>
            <p class="small-text">
                <span data-input="seat_cost_parsed">${data.seat_cost_parsed}</span>
            </p>
        </td>

        <td>
            (<span data-input="total_payments">${data.total_payments}</span>)
            <span data-input="total_paid_parsed">${data.total_paid_parsed}</span>
        </td>
        
        <td>
            (<span data-input="total_upcoming_payments">${data.total_upcoming_payments}</span>)
            <span data-input="total_upcoming_paid_parsed">${data.total_upcoming_paid_parsed}</span>
        </td>
        
        <td><span class="highlight" data-color="${data.status_color}" data-input="status">${data.status}</span></td>
        
        <td data-input="due_date_parsed">${data.due_date_parsed}</td>
        <td class="year-menu-wrapper menu-wrapper" data-dropdown="year-${data.year}">
            <a href="" class="icon-more open-year-menu open-menu"></a>
            <ul class="year-menu menu">
                 ${buttons(data.buttons)}
            </ul>
        </td>`);

        $('.years tbody').prepend(element);
    }
});